<template>
  <div
    class="modal fade"
    id="itemModal"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="itemModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            v-if="isEmpty(item.id)"
            class="modal-title"
            id="itemModalLabel"
          >เพิ่มสินค้าใหม่</h5>
          <h5
            v-else
            class="modal-title"
            id="itemModalLabel"
          >
            แสดงข้อมูล
            <span class="text-primary">{{ item.code }} {{ item.name }}</span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            v-if="!appearForm"
            class="well well-sm text-center"
          >
            <i class="fa fa-cog fa-spin fa-fw"></i>
            {{ message }}
          </div>
          <form
            v-else
            id="dataForm"
            @submit.prevent="saveData"
          >
            <div class="form-group">
              <label>ชื่อ*</label>
              <input
                type="text"
                class="form-control input-sm"
                v-model.trim="item.name"
                placeholder=""
              />
            </div>
            <div class="row">
              <div class="form-group col-sm-4">
                <label>รหัส*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="item.code"
                  placeholder=""
                />
              </div>
              <div class="form-group col-sm-4">
                <label>หน่วย*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="item.unit"
                  placeholder=""
                />
              </div>
              <div class="form-group col-sm-4">
                <label>ราคาต่อหน่วย*</label>
                <input
                  type="text"
                  class="form-control input-sm"
                  v-model.trim="item.unit_price"
                  placeholder=""
                />
              </div>
            </div>

          </form>
        </div>
        <div class="modal-footer d-flex" v-if="appearForm">
          <button class="btn btn-danger" type="button" @click="deleteitem"><i class="fa fa-trash"></i></button>
          <button
            class="btn btn-primary ml-auto"
            form="dataForm"
            :disabled="submitted || !valid"
          >บันทึกข้อมูล</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appearForm: false,
      message: "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่",
      submitted: false,
      item: {
        id: null,
        code:null,
        name: null,
        unit: null,
        unit_price: null,
      },
    };
  },
  mounted() {
    $("#itemModal").on("show.bs.modal", event => {
      this.appearForm = false;
      var button = $(event.relatedTarget);
      var id = button.data("id");

      if (id === undefined) {
        this.appearForm = true;
        return;
      }

      axios
        .get("/items/" + id)
        .then(response => {
          this.item = response.data;
          this.appearForm = true;
        })
        .catch(error => console.log(error));
    });

    $("#itemModal").on("hidden.bs.modal", event => {
      this.resetForm();
    });
  },
  methods: {
    isEmpty: str => !str || 0 === str.length,
    saveData: function() {
      this.disableForm();
      //เตรียมข้อมูล
      let formData = { ...this.item };

      if (this.item.id !== null) formData._method = "put";

      //ส่งข้อมูล
      axios
        .post(
          this.item.id === null
            ? "/items"
            : "/items/" + this.item.id,
          formData
        )
        .then(response => {
          $("#itemModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#itemModal").modal("hide"); //hide model
          this.$emit("update-fail");
        });
    },
    disableForm() {
      this.message = "กำลังดำเนินการ";
      this.submitted = true;
      this.appearForm = false;
    },
    resetForm() {
      this.item = {
        id: null,
        code:null,
        name: null,
        unit: null,
        unit_price: null,
      };
      this.submitted = false;
      this.appearForm = true;
      this.message = "กำลังดาวน์โหลดข้อมูล กรุณารอสักครู่";
    },
    deleteitem() {
      if (!confirm("ยืนยันลบข้อมูลสินค้า?")) {
        return;
      }
      axios
        .delete("/items/" + this.item.id)
        .then(response => {
          $("#itemModal").modal("hide"); //hide model
          this.$emit("update-success");
        })
        .catch(error => {
          $("#itemModal").modal("hide"); //hide model
          let message = error.response.data.message;
          this.$emit("update-fail", message);
        });
      // delete-success
    },
  },
  computed: {
    valid: function() {
      return (
        ! this.isEmpty(this.item.code) &&
        ! this.isEmpty(this.item.name) &&
        ! this.isEmpty(this.item.unit) &&
        ! this.isEmpty(this.item.unit_price)
      );
    },
  },
};
</script>
